import React, { useEffect, useState } from "react";
import {
  showError,
  showSuccess,
} from "../../../../../../../../utils/showMessage.js";
import Form from "react-bootstrap/Form";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import CrossButton from "../../../../../../../common/ButtonSpinner/CrossButton.js";
import GeneralButton from "../../../../../../../common/SaveButton/GeneralButton.js";
import CustomModal from "../../../../../../../common/CustomModal/CustomModal.js";
import Images from "../../../../../../../../utils/images.js";
import "react-toastify/dist/ReactToastify.css";
import { Tooltip } from "@mui/material";

import { restoreDatabase } from "../../../../../../../../api/database_gui.js";

const RestoreDatabasePopup = ({
  visible,
  onClose,
  onRestore,
  dbName,
  appId,
  formData,
  systemUserId,
  setRestoreDatabase,
  loading,
  setLoading,
  databaseInfo,
}) => {
  const [file, setFile] = useState(null);
  const [error, setError] = useState("");

  const handleFileChange = (event) => {
    setFile(event.target.files[0]);
    setError("");
  };

  const handleConfirm = async () => {
    if (!file) {
      setError("Please select a file to restore.");
      return;
    }

    // Set loading state
    if (setLoading) {
      setLoading(true);
    }
    setError("");

    try {
      const response = await restoreDatabase(appId, systemUserId, dbName, file);

      if (response.success) {
        // Use backend success message if available, otherwise fallback to default
        const successMessage = response.data?.message || "Database restored successfully!";
        showSuccess(successMessage);
        onRestore();
        setFile(null);
        onClose();
      } else {
        // Use backend error message if available, otherwise fallback to default
        const errorMessage = response.error || "Error while restoring the database. Please try again.";
        showError(errorMessage);
      }
    } catch (error) {
      showError(
        error.message ||
          "Unexpected error while restoring the database. Please try again."
      );
    } finally {
      // Clear loading state
      if (setLoading) {
        setLoading(false);
      }
    }
  };

  return (
    <CustomModal 
      open={visible} 
      handleClose={onClose}
      width="40%"
    >
      <div>
        <div className="d-flex justify-content-between align-items-center mb-3">
          <div>
            <div className="d-flex align-items-center mb-1">
              {databaseInfo === "MySQL" && (
                <img src={Images.mysql} alt="MySQL" width="24" height="24" className="me-2" />
              )}
              {databaseInfo === "PostgreSQL" && (
                <img src={Images.pssql} alt="PostgreSQL" width="24" height="24" className="me-2" />
              )}
              {databaseInfo === "MSSQL" && (
                <img src={Images.mssql} alt="MSSQL" width="24" height="24" className="me-2" />
              )}
              <h3 className="border-0 customize-column-name mb-0">
                Restore Database
              </h3>
            </div>
            <p className="text-muted mb-0 fs-14px">
              Restore <code className="bg-light px-2 py-1 rounded">{dbName}</code> database from a SQL backup file
            </p>
          </div>
          <CrossButton onClick={onClose} />
        </div>

        <div className="mb-4">
          <div className="d-flex align-items-center mb-2">
            <p className="mb-0 fs-14px">
              Select a SQL file to restore the <strong>{dbName}</strong> database.
            </p>
            <Tooltip
              title="To restore the database, you must import the SQL file from a previous backup. The restoration will only occur if the backup was previously created."
              placement="top-end"
            >
              <img
                src={Images.InfoIcon}
                alt="info"
                width="15"
                height="15"
                className="cursor_pointer ms-2"
              />
            </Tooltip>
          </div>
          
          <Form.Control
            onChange={handleFileChange}
            className="form_input_field"
            type="file"
            accept=".sql"
            placeholder="Choose SQL file..."
          />
          
          {error && (
            <div className="text-danger mt-2 fs-14px">
              {error}
            </div>
          )}
        </div>

        <Row className="pt-4 mb-3 justify-content-end">
          <Col sm="auto">
            <GeneralButton
              onClickEvent={onClose}
              className="me-1"
              value="Cancel"
              color="#505050"
              variant="outlined"
              size="large"
            />
          </Col>
          <Col sm="auto" className="me-sm-2 p-0">
            {loading ? (
              <GeneralButton
                onClickEvent={handleConfirm}
                variant="contained"
                disabled={true}
                className="me-1"
                value={
                  <img src={Images.Loader} width="26px" height="26px" />
                }
                size="large"
              />
            ) : (
              <GeneralButton
                onClickEvent={handleConfirm}
                className="me-1"
                value="Restore"
                variant="contained"
                size="large"
              />
            )}
          </Col>
        </Row>
      </div>
    </CustomModal>
  );
};

export default RestoreDatabasePopup;
